module.exports = __webpack_public_path__ + "static/img/part1.0aade46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/read/part1.png
// module id = Ceo/
// module chunks = 0